import React from 'react';
import PropTypes from 'prop-types';
import { CFormInput, CRow, CCol, CButton, CInputGroup, CInputGroupText } from '@coreui/react';
import { format, subDays, startOfMonth, endOfMonth } from 'date-fns';

const DateRangePicker = ({ dateRange, onDateRangeChange }) => {
  const handleQuickSelect = (days) => {
    const endDate = new Date();
    const startDate = subDays(endDate, days);
    onDateRangeChange({ startDate, endDate });
  };

  const handleMonthSelect = () => {
    const now = new Date();
    onDateRangeChange({
      startDate: startOfMonth(now),
      endDate: endOfMonth(now)
    });
  };

  return (
    <div className="date-range-picker">
      <CRow className="g-3 align-items-center">
        <CCol xs={12} className="mt-3">
          <CButton
            color="dark"
            variant="ghost"
            size="sm"
            onClick={() => handleQuickSelect(7)}
            className="me-2"
          >
            Last 7 days
          </CButton>
          <CButton
            color="dark"
            variant="ghost"
            size="sm"
            onClick={() => handleQuickSelect(30)}
            className="me-2"
          >
            Last 30 days
          </CButton>
          <CButton
            color="dark"
            variant="ghost"
            size="sm"
            onClick={() => handleQuickSelect(90)}
            className="me-2"
          >
            Last 90 days
          </CButton>
          <CButton
            color="dark"
            variant="ghost"
            size="sm"
            onClick={handleMonthSelect}
          >
            This Month
          </CButton>
        </CCol>
      </CRow>
    </div>
  );
};

DateRangePicker.propTypes = {
  dateRange: PropTypes.shape({
    startDate: PropTypes.instanceOf(Date).isRequired,
    endDate: PropTypes.instanceOf(Date).isRequired,
  }).isRequired,
  onDateRangeChange: PropTypes.func.isRequired,
};

export default DateRangePicker;